module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/app_desktop-91f97f46f2060efe08eedb6ac9799b87.png";